import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    standalone: false,
    name: 'stringify'
})
export class StringifyPipe implements PipeTransform {
    transform(value: unknown, indentation = 2): string {
        // change value typed from any to unknown
        return JSON.stringify(value, null, indentation);
    }
}
